/**
 * Types Redux du domaine Acts (Phase 2.F).
 *
 * <p>Aligné sur le contrat back :
 * <ul>
 *   <li>POST /acts → Long</li>
 *   <li>PUT /acts/{id} → Long</li>
 *   <li>DELETE /acts/{id} → void</li>
 *   <li>GET /acts/{id} → ActsResponse</li>
 *   <li>GET /acts?search&page&size → Map paginée</li>
 *   <li>POST/PUT/DELETE/GET-by-id /acts-price-insurer</li>
 *   <li>GET /acts-price-insurer/by-insurer/{insurerId} → List</li>
 * </ul>
 *
 * <p>Les types {@code FETCH_ACTS_*} restent conservés tels quels (le saga
 * consomme l'alias rétro-compatible {@code filterActs} qui aplatit la
 * réponse en tableau plat). En revanche les anciens
 * {@code GET_ACTS_PRICE_INSURER_FILTER_*} ont été renommés en
 * {@code GET_ACTS_PRICE_INSURER_BY_INSURER_*} (2026-05-26) — le service
 * sous-jacent est et a toujours été {@code GET /acts-price-insurer/by-insurer/{id}}.
 */

export const CREATE_ACTS_REQUEST = 'CREATE_ACTS_REQUEST';
export const CREATE_ACTS_SUCCESS = 'CREATE_ACTS_SUCCESS';
export const CREATE_ACTS_FAILURE = 'CREATE_ACTS_FAILURE';

export const UPDATE_ACTS_REQUEST = 'UPDATE_ACTS_REQUEST';
export const UPDATE_ACTS_SUCCESS = 'UPDATE_ACTS_SUCCESS';
export const UPDATE_ACTS_FAILURE = 'UPDATE_ACTS_FAILURE';

export const FETCH_ACTS_REQUEST = 'FETCH_ACTS_REQUEST';
export const FETCH_ACTS_SUCCESS = 'FETCH_ACTS_SUCCESS';
export const FETCH_ACTS_FAILURE = 'FETCH_ACTS_FAILURE';

export const GET_ACTS_BY_ID_REQUEST = 'GET_ACTS_BY_ID_REQUEST';
export const GET_ACTS_BY_ID_SUCCESS = 'GET_ACTS_BY_ID_SUCCESS';
export const GET_ACTS_BY_ID_FAILURE = 'GET_ACTS_BY_ID_FAILURE';

export const DELETE_ACTS_REQUEST = 'DELETE_ACTS_REQUEST';
export const DELETE_ACTS_SUCCESS = 'DELETE_ACTS_SUCCESS';
export const DELETE_ACTS_FAILURE = 'DELETE_ACTS_FAILURE';

export const GET_ACTS_PRICE_INSURER_BY_INSURER_REQUEST = "GET_ACTS_PRICE_INSURER_BY_INSURER_REQUEST";
export const GET_ACTS_PRICE_INSURER_BY_INSURER_SUCCESS = "GET_ACTS_PRICE_INSURER_BY_INSURER_SUCCESS";
export const GET_ACTS_PRICE_INSURER_BY_INSURER_FAILURE = "GET_ACTS_PRICE_INSURER_BY_INSURER_FAILURE";

export const CREATE_ACTS_PRICE_INSURER_REQUEST = "CREATE_ACTS_PRICE_INSURER_REQUEST";
export const CREATE_ACTS_PRICE_INSURER_SUCCESS = "CREATE_ACTS_PRICE_INSURER_SUCCESS";
export const CREATE_ACTS_PRICE_INSURER_FAILURE = "CREATE_ACTS_PRICE_INSURER_FAILURE";

export const UPDATE_ACTS_PRICE_INSURER_REQUEST = "UPDATE_ACTS_PRICE_INSURER_REQUEST";
export const UPDATE_ACTS_PRICE_INSURER_SUCCESS = "UPDATE_ACTS_PRICE_INSURER_SUCCESS";
export const UPDATE_ACTS_PRICE_INSURER_FAILURE = "UPDATE_ACTS_PRICE_INSURER_FAILURE";

export const DELETE_ACTS_PRICE_INSURER_REQUEST = "DELETE_ACTS_PRICE_INSURER_REQUEST";
export const DELETE_ACTS_PRICE_INSURER_SUCCESS = "DELETE_ACTS_PRICE_INSURER_SUCCESS";
export const DELETE_ACTS_PRICE_INSURER_FAILURE = "DELETE_ACTS_PRICE_INSURER_FAILURE";
